<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Avisos </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="tabs">
        <v-tabs v-model="tab" bg-color="primary">
          <v-tab value="one">Gestión</v-tab>
          <v-tab value="two">Avisos Asignados</v-tab>
        </v-tabs>

        <v-card-text>
          <v-window v-model="tab">
            <v-window-item value="one">
              <div class="content_accion">
                <div>
                  <v-text-field
                    v-model="search"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                  ></v-text-field>
                </div>
                <div>
                  <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2 reload"
                    @click="getNoticesByUser()"
                  >
                  </v-btn>
                  <v-btn
                    v-bind="props"
                    class="text-none mb-4"
                    prepend-icon="mdi-plus"
                    color="indigo-darken-3"
                    @click="openDialogRegistrar('registrar')"
                  >
                    Registrar
                  </v-btn>
                </div>
              </div>
              <div class="container_table">
                <v-data-table
                  class="content_table"
                  :headers="headersTable"
                  fixed-header
                  :height="250"
                  :items="listNoticesByUser"
                  :search="search"
                  :loading="loading"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <tr>
                      <td>
                        <div class="actions">
                          <div class="actions">
                            <v-tooltip activator="parent" location="top"
                              >Eliminar</v-tooltip
                            >
                            <v-btn
                              class="edit"
                              icon="mdi-delete"
                              color="error"
                              @click="deleteNotice(item)"
                            ></v-btn>
                          </div>
                          <div class="actions">
                            <v-tooltip activator="parent" location="top"
                              >Editar</v-tooltip
                            >
                            <v-btn
                              class="edit"
                              icon="mdi-pencil"
                              color="indigo-darken-3"
                              @click="openDialogRegistrar('edit', item)"
                            ></v-btn>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-window-item>

            <v-window-item value="two">
              <div class="content_accion">
                <div>
                  <v-text-field
                    v-model="search2"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                  ></v-text-field>
                </div>
                <div>
                  <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    @click="getAvisosAsignados()"
                  >
                  </v-btn>
                </div>
              </div>
              <div class="container_table">
                <v-data-table
                  class="content_table"
                  :headers="headersAvisosAsignados"
                  fixed-header
                  :height="250"
                  :items="listAvisosAsignados"
                  :search="search2"
                  :loading="loadingAvisosAsignados"
                >
                </v-data-table>
              </div>
            </v-window-item>
          </v-window>
        </v-card-text>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>

  <!-- Dialog de registro de grupos-->
  <template>
    <v-dialog width="650" v-model="showDialogRegistrar">
      <v-card :title="tituloRegistroEdit">
        <v-divider class="mx-3"></v-divider>
        <v-card-text>
          <v-container>
            <v-row v-if="!loadingRegistro">
              <v-col cols="6">
                <label>Título</label>
                <v-text-field
                  id="titulo"
                  v-model="titulo"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <label>Fecha Caducidad</label>
                <v-text-field
                  v-model="fechaCaducidadInput"
                  placeholder="Clic para seleccionar la fecha"
                  readonly
                  @click="openDialogDate()"
                >
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <label>Usuarios</label>
              </v-col>
              <v-col cols="4">
                <span>{{ totalUsuarios }}</span>
              </v-col>
              <v-col cols="4">
                <v-btn
                  variant="flat"
                  class="text-none mb-4"
                  text="Agregar usuarios"
                  color="indigo-darken-3"
                  prepend-icon="mdi-plus"
                  @click="opendialogAgregar()"
                ></v-btn>
              </v-col>
              <v-col cols="12">
                <label>Descripción</label>
                <v-textarea required v-model="description"></v-textarea>
              </v-col>
            </v-row>
            <div class="content_load" v-if="loadingRegistro">
              <v-progress-circular
                :size="100"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
              <i>Espere un momento</i>
            </div>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions v-if="!loadingRegistro">
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            @click="closeDialogRegistrar"
          ></v-btn>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            :loading="isLoading"
            @click="validateInputs()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!-- Seleccione una Fecha -->
  <template>
    <v-dialog v-model="dialogDate" width="400px" persistent>
      <v-card>
        <v-card-title>
          <div>
            <span class="text-h5">Seleccione una Fecha</span>
          </div>
        </v-card-title>

        <v-card-text>
          <v-date-picker
            v-model="inputDate"
            :min="minDate"
            @click="selectedDate()"
          >
          </v-date-picker>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="flat"
            class="text-none mb-4"
            text="Aceptar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            @click="closeDialogDate"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <!-- Dialog de agregar usuarios-->
  <template>
    <v-dialog persistent width="1024" v-model="dialogAdd">
      <v-card title="Agregar Usuario (s)">
        <v-divider class="mx-3"></v-divider>
        <v-card-text v-if="!isLoadingAdd">
          <div class="content_accion">
            <div>
              <v-text-field
                v-model="searchAdd"
                label="Buscar..."
                prepend-inner-icon="mdi-magnify"
                single-line
                variant="outlined"
                hide-details
                class="filter"
              ></v-text-field>
            </div>
            <div>
              <v-btn
                variant="flat"
                class="text-none mb-4 close"
                text="Cerrar"
                color="red"
                prepend-icon="mdi-close"
                @click="closeDialogAgregar"
              ></v-btn>

              <v-btn
                variant="flat"
                class="text-none mb-4 selectAll"
                text="Seleccionar todos"
                color="indigo-darken-3"
                prepend-icon="mdi-content-save"
                @click="closeDialogAgregar('all')"
              ></v-btn>

              <v-btn
                variant="flat"
                class="text-none mb-4 selectAll"
                text="Deseleccionar todos"
                color="indigo-darken-3"
                prepend-icon="mdi-close"
                @click="diselectedAll()"
              ></v-btn>

              <v-btn
                variant="flat"
                class="text-none mb-4"
                text="Agregar"
                color="indigo-darken-3"
                prepend-icon="mdi-content-save"
                :disabled="validateForm() || isLoadingAdd"
                @click="closeDialogAgregar()"
              ></v-btn>
            </div>
          </div>
          <div class="container_table">
            <v-data-table
              class="content_table"
              :headers="headersAddUser"
              fixed-header
              :items="listUsuarios"
              :search="searchAdd"
              :loading="loadingAdd"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <tr>
                  <td>
                    <div class="actions">
                      <v-checkbox
                        :id="'checked_' + item.id"
                        v-model="checked[item.id]"
                        @change="handleCheckboxChange(item.id)"
                      ></v-checkbox>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <div class="content_load" v-if="isLoadingAdd">
          <v-progress-circular
            :size="100"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <i>Espere un momento</i>
        </div>
      </v-card>
    </v-dialog>
  </template>

  <!--Dialog de eliminacion-->
  <template>
    <v-dialog v-model="dialogDelete" width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Confirmación</span>
        </v-card-title>
        <v-card-text>
          <div v-if="!isLoadingEliminar">
            <div class="text-center">
              <img src="@/assets/images/warning.png" />
            </div>
            <div class="description-text">
              <p>¿Está seguro de eliminar el aviso?</p>
            </div>
          </div>
          <div class="content_load" v-if="isLoadingEliminar">
            <v-progress-circular
              :size="100"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
          </div>
        </v-card-text>
        <v-card-actions class="actions-buttons">
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogDelete = false"
            variant="flat"
            class="text-none mb-4"
            text="Cerrar"
            color="red"
            prepend-icon="mdi-close"
            >Cerrar</v-btn
          >
          <v-btn
            :loading="isLoadingEliminar"
            @click="eliminarAviso"
            variant="flat"
            class="text-none mb-4"
            text="Guardar"
            color="indigo-darken-3"
            prepend-icon="mdi-content-save"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
</template>

<script>
import { NoticeService } from "@/services/NoticesService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "NoticeAdminComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  props: ["totalNotificaciones"],
  data() {
    return {
      listNoticesByUser: [],
      tab: null,
      search: "",
      loading: true,
      listUsuarios: [],
      showDialogRegistrar: false,
      fechaCaducidad: "",
      titulo: "",
      description: "",
      datePickerVisible: false,
      dialogDate: false,
      inputDate: new Date(),
      minDate: new Date(new Date().getTime()).toISOString().substr(0, 10), // Establece la fecha mínima como la de hoy
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      dialogAdd: false,
      isLoadingAdd: false,
      headersAddUser: [
        { title: "No.", key: "number" },
        { title: "Nombre (s)", key: "name" },
        { title: "Apellidos", key: "last_name" },
        { title: "Username", key: "username" },
        { title: "Seleccionar", key: "actions" },
      ],
      headersTable: [
        { title: "Título", key: "titulo" },
        { title: "Descripción", key: "descripcion" },
        { title: "Fecha Caducidad", key: "fecha_caduca" },
        { title: "Fecha Creación", key: "created_at" },
        { title: "Acciones", key: "actions" },
      ],
      headersAvisosAsignados: [
        { title: "Título", key: "titulo" },
        { title: "Descripción", key: "descripcion" },
        { title: "Autor", key: "autor" },
      ],
      loadingAdd: true,
      searchAdd: "",
      selectedItems: [],
      checked: {},
      loadingRegistro: false,
      isLoadingEliminar: false,
      dialogDelete: false,
      idAvisoG: "",
      listAvisosAsignados: [],
      loadingAvisosAsignados: true,
      totalUsuarios: 0,
      tipoForm: "registro",
      tituloRegistroEdit: "Crear Avisos",
      search2: "",
      fechaCaducidadInput: "",
    };
  },
  beforeMount() {
    this.getNoticesByUser();
    this.getUsers();
    this.getAvisosAsignados();
  },
  methods: {
    getNoticesByUser: async function () {
      let idUser = await NoticeService.encriptar(localStorage.getItem("ID"));
      this.loading = true;
      await NoticeService.getNoticesByAutor(idUser.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listNoticesByUser = resp.response;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0001",
              description: resp.msg,
            };
          }
        })
        .catch((error) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: error,
          };
        });
    },
    getUsers: async function () {
      await NoticeService.getUsersByWorkplace()
        .then((resp) => {
          if (!resp.error) {
            this.listUsuarios = resp.response;
            let i = 1;
            this.listUsuarios.forEach((element) => {
              element.number = i;
              i++;
            });
            setTimeout(() => {
              this.loadingAdd = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0002",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    openDialogRegistrar(tipo, item) {
      this.showDialogRegistrar = true;
      this.tituloRegistroEdit = "Crear Aviso";
      if (tipo == "edit") {
        this.tituloRegistroEdit = "Editar Aviso";
        this.tipoForm = tipo;
        this.titulo = item.titulo;
        this.description = item.descripcion;
        this.idAvisoG = item.id_aviso;
        this.fechaCaducidad = item.fecha_caduca;
        item.usuarios.forEach((el) => {
          el.forEach((el1) => {
            this.checked[el1.id] = true;
            this.handleCheckboxChange(el1.id);
          });
        });
      }
    },
    closeDialogRegistrar() {
      this.showDialogRegistrar = false;
      this.fechaCaducidad = "";
      this.titulo = "";
      this.description = "";
      this.selectedItems = [];
      this.totalUsuarios = 0;
      this.tipoForm = "registro";
      this.diselectedAll();
    },
    openDialogDate() {
      this.dialogDate = true;
    },
    closeDialogDate() {
      this.inputDate = new Date();
      this.dialogDate = false;
    },
    selectedDate: function () {
      const YEAR_INPUT = this.inputDate.getFullYear();
      const MONTH_INPUT = ("0" + (this.inputDate.getMonth() + 1)).slice(-2);
      const DAY_INPUT = ("0" + this.inputDate.getDate()).slice(-2);
      const DATE_SELECTED = `${YEAR_INPUT}-${MONTH_INPUT}-${DAY_INPUT}`;
      const DATE_SELECTED2 = `${DAY_INPUT}-${MONTH_INPUT}-${YEAR_INPUT}`;
      this.fechaCaducidad = DATE_SELECTED;
      this.fechaCaducidadInput = DATE_SELECTED2;
    },
    opendialogAgregar() {
      this.dialogAdd = true;
    },
    closeDialogAgregar(tipo) {
      if (tipo == "all") {
        this.selectedAll();
      }
      this.dialogAdd = false;
    },
    handleCheckboxChange(itemId) {
      if (this.checked[itemId]) {
        // Si está marcado, agrega el item a selectedItems
        this.selectedItems.push(itemId);
      } else {
        // Si se desmarca, elimina el item de selectedItems
        this.selectedItems = this.selectedItems.filter((id) => id !== itemId);
      }

      this.totalUsuarios = this.selectedItems.length;
    },
    selectedAll() {
      this.listUsuarios.forEach((user) => {
        this.checked[user.id] = true;
        this.handleCheckboxChange(user.id);
      });
    },
    diselectedAll() {
      this.listUsuarios.forEach((user) => {
        this.checked[user.id] = false;
        this.handleCheckboxChange(user.id);
      });
    },
    validateInputs() {
      const regex = /^[a-zA-Z0-9 ]+$/;
      if (this.titulo == "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "El título es requerido",
        };
        return false;
      } else if (this.titulo !== "") {
        let validarTxt = regex.test(this.titulo);
        if (!validarTxt) {
          this.dialogData = {
            openDialog: true,
            title: "Error",
            description: "No se aceptan caracteres especiales",
          };
          return false;
        }
      }

      if (this.description === "") {
        this.dialogData = {
          openDialog: true,
          title: "Error",
          description: "La descripción es requerida",
        };
        return false;
      }

      if (this.tipoForm == "edit") {
        this.editNotice();
      } else {
        this.saveNotice();
      }
    },
    validateForm() {
      const validate = this.selectedItems.length === 0;
      return validate;
    },
    saveNotice: async function () {
      try {
        this.loadingRegistro = true;
        this.loading = true;

        const arreglo = await this.encriptarTodos(this.selectedItems);

        const dataForm = new FormData();
        dataForm.append("titulo", this.titulo);
        dataForm.append("descripcion", this.description);
        dataForm.append("username", localStorage.getItem("USERNAME"));
        dataForm.append("fecha_caduca", this.fechaCaducidad);
        dataForm.append("usuarios", JSON.stringify(arreglo));

        const resp = await NoticeService.saveNotice(dataForm);

        if (!resp.error) {
          this.snackbarData = {
            openSnackbar: true,
            description: "Se registró el aviso exitosamente!",
          };
          this.getNoticesByUser();
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        } else {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema 0003",
            description: resp.msg,
          };
        }
      } catch (error) {
        this.dialogData = {
          openDialog: true,
          title: "Ocurrió un Problema",
          description: error,
        };
      } finally {
        this.loadingRegistro = false;
        this.showDialogRegistrar = false;
        this.titulo = "";
        this.description = "";
        this.selectedItems = [];
        this.fechaCaducidad = "";
        this.totalUsuarios = 0;
        this.loading = false;
        this.diselectedAll();
        this.searchAdd = "";
        this.search = "";
        this.tipoForm = "registro";
        this.closeDialogRegistrar();
      }
    },
    editNotice: async function () {
      this.loadingRegistro = true;
      this.loading = true;
      let idAviso = await NoticeService.encriptar(this.idAvisoG);
      const dataForm = new FormData();
      dataForm.append("titulo", this.titulo);
      dataForm.append("descripcion", this.description);
      dataForm.append("fecha_caduca", this.fechaCaducidad);

      for (let i = 0; i < this.selectedItems.length; i++) {
        const element = this.selectedItems[i];
        const element1 = await NoticeService.encriptar(element);
        this.selectedItems[i] = element1.msg;
      }
      dataForm.append("usuarios", JSON.stringify(this.selectedItems));

      await NoticeService.editNotice(idAviso.msg, dataForm)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se actualizó el aviso exitosamente!",
            };
            this.getNoticesByUser();
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0004",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.loadingRegistro = false;
      this.showDialogRegistrar = false;
      this.titulo = "";
      this.description = "";
      this.selectedItems = [];
      this.fechaCaducidad = "";
      this.totalUsuarios = 0;
      this.loadingRegistro = false;
      this.loading = false;
      this.diselectedAll();
      this.searchAdd = "";
      this.search = "";
      this.tipoForm = "registro";
      this.closeDialogRegistrar();
    },
    deleteNotice(item) {
      this.dialogDelete = true;
      this.idAvisoG = item.id_aviso;
    },
    eliminarAviso: async function () {
      this.isLoadingEliminar = true;
      this.loading = true;
      let idAviso = await NoticeService.encriptar(this.idAvisoG);

      await NoticeService.deleteNotice(idAviso.msg)
        .then((resp) => {
          if (!resp.error) {
            this.snackbarData = {
              openSnackbar: true,
              description: "Se eliminó el aviso exitosamente!",
            };
            this.getNoticesByUser();
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0005",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });

      this.dialogDelete = false;
      this.isLoadingEliminar = false;
      this.search = "";
    },
    getAvisosAsignados: async function () {
      let idU = await NoticeService.encriptar(localStorage.getItem("ID"));
      this.loadingAvisosAsignados = true;
      await NoticeService.getNoticesByUser(idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listAvisosAsignados = resp.response;
            setTimeout(() => {
              this.loadingAvisosAsignados = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema 0006",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    encriptarTodos: async function (arrUSers) {
      const dataUsers = new FormData();
      dataUsers.append("usuarios", JSON.stringify(arrUSers));

      try {
        const resp = await NoticeService.encriparTodos(dataUsers);
        if (!resp.error) {
          return resp.response; // Devuelve el arreglo si no hay error
        } else {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema 0007",
            description: resp.msg,
          };
          return []; // Devuelve un arreglo vacío en caso de error
        }
      } catch (err) {
        console.log(err);
        return []; // Devuelve un arreglo vacío si ocurre un error
      }
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.body-table {
  overflow-x: auto;
  display: block;
  white-space: nowrap;
}

.actions {
  display: flex;
  align-items: center;
  float: left;
  margin-right: 1vh;
  width: 9vh !important;
  height: 9vh !important;
}

.close {
  margin-right: 2px;
}

.description-text {
  display: flex;
  justify-content: center;
}
.description-text p {
  width: 90%;
  text-align: center;
}

img {
  height: 230px;
  width: auto;
  padding: 40px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.selectAll {
  margin-right: 2px;
}

.reload {
  margin-top: -2vh;
}
</style>
